import { twMerge } from 'tailwind-merge';

export const ErrorMessage = ({ children, className }: { children?: React.ReactNode; className?: string }) => {
  if (!children) return null;
  return <div className={twMerge('text-error mt-2 text-sm', className)}>{children}</div>;
};
